
















































































import Vue from 'vue';
import Glide from '@glidejs/glide';
import Launcher from './Launcher.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import HiddenInPlainSightLogout from './HiddenInPlainSightLogout.vue';
import { Launcher as TLauncher } from '../types';

export default Vue.extend({
  mounted() {
    this.$nextTick(this.initializeCarousel);
  },

  beforeDestroy() {
    const cloneButtons = document.querySelectorAll<HTMLButtonElement>(
      '.glide__slide--clone button'
    );
    for (const button of cloneButtons) {
      button.removeEventListener('click', this.handleCloneClick);
    }
  },

  data(): { glide?: Glide } {
    return {
      glide: undefined,
    };
  },

  computed: {
    ...mapState(['launched', 'brand']),
    ...mapGetters(['primaryApp', 'otherApps']),

    hasPrimaryImage(): boolean {
      return String(this.primaryApp?.primary_image_url || '').length > 0;
    },

    isCarousel(): boolean {
      return this.otherApps.length > 4;
    },
  },

  methods: {
    ...mapActions(['launch']),

    initializeCarousel() {
      const glideConfig: Partial<Glide.Options> = {
        dragThreshold: 160,
        gap: 16,
        peek: 8,
        perView: Math.min((this.otherApps as TLauncher[]).length, 4),
        startAt: 0,
        throttle: 0,
        type: 'carousel',
      };

      // If there aren't at least 4 launcher apps, don't render the arrows or allow drag/swipe gestures.
      if (!this.isCarousel) {
        glideConfig.dragThreshold = false;
        glideConfig.swipeThreshold = false;
      }

      this.glide = new Glide('.glide', glideConfig);
      this.glide.mount();

      this.$nextTick(() => {
        // The GlideJs-generated clones don't seem to be getting Vue event handler bindings...
        const cloneButtons = document.querySelectorAll<HTMLButtonElement>(
          '.glide__slide--clone button'
        );
        for (const button of cloneButtons) {
          button.addEventListener('click', this.handleCloneClick);
        }
      });
    },

    handleCloneClick(event: MouseEvent) {
      const launcherId = (event.target as HTMLButtonElement | undefined)
        ?.dataset?.launcherId;
      const launcher = (this.otherApps as TLauncher[]).find(
        otherApp => otherApp.id === Number(launcherId)
      );
      if (!launcher) {
        return;
      }

      this.launch(launcher);
    },

    next() {
      this.glide?.go('>');
    },

    previous() {
      this.glide?.go('<');
    },
  },

  components: {
    Launcher,
    HiddenInPlainSightLogout,
  },
});
